import type { CaseStatus } from '@/components/CaseViewModal';

const STATUS_STYLES: Record<CaseStatus, string> = {
    'Draft': 'bg-[#f5f5f5] text-[#888]',
    'New': 'bg-primary/10 text-primary',
    'Assigned': 'bg-green-100 text-green-700',
    'In Progress': 'bg-[#e8e8e8] text-[#555]',
    'Resolved': 'bg-green-100 text-green-700',
    'Reopen': 'bg-blue-100 text-blue-600',
};

export default function StatusBadge({ status }: { status: CaseStatus }) {
    return (
        <span className={`inline-block rounded-[2px] px-3 py-1 text-[13px] font-medium ${STATUS_STYLES[status]}`}>
            {status}
        </span>
    );
}
